import { removeCurrency } from '@rhybus/common-functions'
//notification object should be below format
// {
//   ItemID: string,   NotificationType: 'NOTIFICATION' | 'ACTION',
//   Subject: string,  Module: string,  IsRead: boolean,
//   ItemCreated: string,  ItemModified: string,  id: string
// }
export const getTabsConfig = (notifications: any[]) => [
  {
    key: 'all',
    label: 'All',
    isDotIcon: false,
    count: notifications?.length,
    filter: () => true
  },
  {
    key: 'actions',
    label: 'Action Required',
    isDotIcon: true,
    dotIconBgColor: '#AB1CF2',
    NotificationsType: 1,
    count: notifications.filter(item => item.NotificationType?.toUpperCase() === 'ACTION').length,
    filter: (item: any) => item.NotificationType?.toUpperCase() === 'ACTION'
  },
  {
    key: 'notifications',
    label: 'Info',
    isDotIcon: true,
    dotIconBgColor: '#107FC4',
    NotificationsType: 2,
    count: notifications.filter(item => item.NotificationType?.toUpperCase() === 'NOTIFICATION').length,
    filter: (item: any) => item.NotificationType?.toUpperCase() === 'NOTIFICATION'
  }
]

export const workflowItems = [
  { id: 1, label: 'Training', statusCode: 11 },
  { id: 2, label: 'Seat Validation', statusCode: 18 },
  { id: 3, label: 'Execution', statusCode: 3 },
  { id: 4, label: 'Utilization', statusCode: 12 },
  { id: 5, label: 'Billing', statusCode: 13 },
  { id: 6, label: 'Reconciliation', statusCode: 14 },
  { id: 7, label: 'Closure', statusCode: 25 }
]

export const workflowItemsGrant = [
  { id: 1, label: 'Initiated', statusCode: 22 },
  { id: 2, label: 'Internal Review', statusCode: 30 },
  { id: 3, label: 'DSCA Funding', statusCode: 3 },
  { id: 4, label: 'Implemented', statusCode: 17 },
  { id: 5, label: 'Active', statusCode: 28 },
  { id: 6, label: 'Closure', statusCode: 32 },
]

export const workflowStatusColorMap: Record<number, string> = {
  1: '#374DFD',
  2: '#6ECD4C',
  3: '#DB33CF',
  4: '#C89F16',
  5: '#7C8C02',
  6: '#469204',
  7: '#273CC2',
  8: '#C99806',
  9: '#008714',
  10: '#D70427',
  11: '#B0500C',
  12: '#0295DE',
  13: '#15A78C',
  14: '#DA8A00',
  15: '#9825CD',
  16: '#049254',
  17: '#0295DE',
  18: '#DE9502',
  19: '#CE6700',
  20: '#374DFD',
  21: '#00A37D',
  22: '#0C17B0',
  23: '#D4A600',
  24: '#A70CB0',
  25: '#921EFF',
  32: '#B8390A',
  26: '#A77915',
  27: '#7115A7',
  28: '#7BA715',
  29: '#155CA7',
  30: '#DE9502',

}

export const homeKpiStatusColorMap: Record<string, { color: string, bg: string }> = {
  '7': { color: '#273CC2', bg: '#DCE1FF' },
  '8': { color: '#C99806', bg: '#FFF4DC' },
  '9': { color: '#008714', bg: '#D9FFDF' },
  '10': { color: '#D70427', bg: '#FFE2E7' },
  '15': { color: '#9825CD', bg: '#F3E1FF' }
}
//Dashboard kpis
export const KpisData = [
  {
    Title: 'Total Cases',
    iconname: 'icon-rb-total-requirements',
    ColorCode: '7',
    showicon: true,
    isKpiBgcolor: true,
    value: 50,
    Filter: (_item: any) => true,
    sumAmountField: 'TotalCases',
    layout: {
      showIcon: true,
      showSecondaryValue: true,
      iconPosition: 'left',
      secondaryValuePosition: 'below-title'
    }
  },
  {
    Title: 'Total Trainings',
    iconname: 'icon-rb-trainig-student',
    ColorCode: '15',
    showicon: true,
    value: 80,
    isKpiBgcolor: true,
    Filter: (_item: any) => true,
   sumAmountField: 'TotalTrainings',
    layout: {
      showIcon: true,
      showSecondaryValue: true,
      iconPosition: 'left',
      secondaryValuePosition: 'below-title'
    }
  },
  {
    Title: 'Active Trainings',
    iconname: 'icon-rb-in-progress',
    showicon: true,
    ColorCode: '8',
    value: 0,
    isKpiBgcolor: true,
    Filter: (item: any) => parseFloat(removeCurrency(item?.fundedAmount) || '0') === 0 && parseFloat(removeCurrency(item?.unfundedAmount) || '0') === 0,
   sumAmountField: 'ActiveTrainings',
    layout: {
      showIcon: true,
      showSecondaryValue: true,
      iconPosition: 'left',
      secondaryValuePosition: 'below-title'
    }
  },
  {
    Title: 'Completed Trainings',
    iconname: 'icon-rb-funded',
    showicon: true,
    ColorCode: '9',
    value: 0,
    isKpiBgcolor: true,
    Filter: (item: any) => parseFloat(removeCurrency(item?.fundedAmount) || '0') > 0,
    sumAmountField: 'CompletedTrainings',
    layout: {
      showIcon: true,
      showSecondaryValue: true,
      iconPosition: 'left',
      secondaryValuePosition: 'below-title'
    }
  }
]


export const calendarEvents = [
  { ID: 1, title: 'Budget Validation',    EventDate: '2026-04-15T09:00:00', EndDate: '2026-04-15T10:00:00', FreeBusy: null, rrule: null, extendedProps: {}, _instance: null, _def: null },
  { ID: 2, title: 'Weekly Agendas',       EventDate: '2026-04-17T10:00:00', EndDate: '2026-04-17T11:00:00', FreeBusy: null, rrule: null, extendedProps: {}, _instance: null, _def: null },
  { ID: 3, title: 'Open Government',      EventDate: '2026-04-19T13:00:00', EndDate: '2026-04-19T14:00:00', FreeBusy: null, rrule: null, extendedProps: {}, _instance: null, _def: null },
  { ID: 4, title: 'Acquisition Plan Review', EventDate: '2026-04-21T09:00:00', EndDate: '2026-04-21T10:30:00', FreeBusy: null, rrule: null, extendedProps: {}, _instance: null, _def: null },
  { ID: 5, title: 'Air Force Base Meeting',  EventDate: '2026-04-23T14:00:00', EndDate: '2026-04-23T15:30:00', FreeBusy: null, rrule: null, extendedProps: {}, _instance: null, _def: null },
  { ID: 6, title: 'CAE Engineer Course',  EventDate: '2026-04-25T08:00:00', EndDate: '2026-04-25T16:00:00', FreeBusy: null, rrule: null, extendedProps: {}, _instance: null, _def: null },
]

export const quicklinksItems = [
  {
    ID: 1,
    Title: 'Google',
    URL: 'https://www.google.com'
  },
  {
    ID: 2,
    Title: 'Facebook',
    URL: 'https://www.facebook.com'
  },
  {
    ID: 3,
    Title: 'YouTube',
    URL: 'https://www.youtube.com'
  },
  {
    ID: 4,
    Title: 'LinkedIn',
    URL: 'https://www.linkedin.com'
  }
]